const API_BASE = import.meta.env.VITE_API_BASE_URL ?? '/api';

/**
 * Les URLs Instagram CDN (fbcdn / cdninstagram) expirent ~7j et ne supportent
 * pas CORS. Le backend expose `/image-proxy?u=<base64url>` qui va chercher
 * l'image côté serveur et la sert avec Cache-Control long.
 */
export function proxyImage(url: string | null | undefined): string | undefined {
  if (!url) return undefined;
  // Les URLs déjà relatives (ex: data: uris, /assets/*) passent telles quelles.
  if (!/^https?:\/\//i.test(url)) return url;
  const encoded = base64UrlEncode(url);
  return `${API_BASE}/image-proxy?u=${encoded}`;
}

function base64UrlEncode(input: string): string {
  const bytes = new TextEncoder().encode(input);
  let binary = '';
  for (const b of bytes) binary += String.fromCharCode(b);
  return btoa(binary)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}
